module.exports = __webpack_public_path__ + "img/P&g.6e86c9ab.png";